module.exports = __webpack_public_path__ + "img/timer.21e0f7a8.svg";